import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import mindSharperImg from '../images/Mind-Sharper-1.webp'; 

const FOOTER_SECTIONS = [
  {
    title: 'Services',
    links: [
      ['Web Development', '/services/web-development'],
      ['AI & Automation', '/services/ai-automation'],
      ['UI/UX Design', '/services/ui-ux-design'],
      ['App Development', '/services/app-development'],
      ['SEO', '/services/seo'],
      ['Digital Marketing', '/services/digital-marketing'],
    ],
  },
  { title: 'Company', links: [['About Us','/about'],['Blog','/blog'],['Contact','/contact'],['Careers','/contact'],  ,['FAQ','/faq'], ['Privacy Policy','/privacy-policy']] },
  { title: 'Contact',  links: [['codeviora@gmail.com','mailto:codeviora@gmail.com'],['+91 8699393272','tel:+918699393272'],['Chandigarh, India','/contact']] },
  
];

// ── Social Links ──────────────────────────────────────────
const SOCIALS = [
  { id: 'linkedin', href: 'https://www.linkedin.com/company/codeviora/', label: 'CodeViora on LinkedIn', icon: 'fab fa-linkedin-in' },
  { id: 'facebook', href: 'https://www.facebook.com/CodeViora/', label: 'CodeViora on Facebook', icon: 'fab fa-facebook-f' },
];

// ── Ads Data ──────────────────────────────────────────────
const ADS = [
  {
    id: 'webtoolspark',
    href: 'https://webtoolspark.com/',
    label: 'WebToolSpark',
    content: 'logo',
    title: 'WEB TOOL\nSPARK',
    tagline: 'Free CSS, SEO & Image tools',
  },
  {
    id: 'letfind',
    href: 'https://letfind.in/',
    label: 'LetFind - Best Amazon Deals & Buying Guides',
    content: 'logo',
    title: 'LET\nFIND',
    tagline: 'Best Amazon Deals & Guides',
  },
  {
    id: 'mindsharper',
    href: 'https://play.google.com/store/apps/details?id=com.app.mindsharpermobile&pcampaignid=web_share',
    label: 'Mind Sharper',
    content: 'image',
  },
];

// ── Side Ad Carousel (Desktop only) ────────────────────────
function SideAds() {
  const [visible, setVisible] = useState(false);
  const [closed, setClosed]   = useState(false);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 1500);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    if (closed) return;
    const t = setInterval(() => setCurrent(i => (i + 1) % ADS.length), 4000);
    return () => clearInterval(t);
  }, [closed]);

  if (closed) return null;

  const ad = ADS[current];

  return (
    // hidden on mobile/tablet — only show from md breakpoint up
    <div
      className="hidden md:block"
      style={{
        position: 'fixed',
        top: '45%',
        left: 0,
        zIndex: 999,
        transform: visible ? 'translateX(0)' : 'translateX(-110%)',
        transition: 'transform 0.6s cubic-bezier(0.34,1.56,0.64,1)',
      }}
    >
      <div style={{ position: 'relative', width: '150px' }}>
        <button
          onClick={() => setClosed(true)}
          aria-label="Close ads"
          style={{
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            zIndex: 10,
            width: '22px',
            height: '22px',
            borderRadius: '50%',
            background: '#111',
            border: '1.5px solid rgba(255,255,255,0.2)',
            color: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            fontSize: '12px',
            lineHeight: 1,
          }}
        >
          ✕
        </button>

        <a
          href={ad.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={ad.label}
          style={{ display: 'block', textDecoration: 'none' }}
        >
          {ad.content === 'logo' ? (
            <div
              style={{
                background: '#0a0a0f',
                border: '1px solid rgba(255,255,255,0.12)',
                borderRadius: '0 12px 12px 0',
                padding: '12px 16px',
                display: 'flex',
                flexDirection: 'column',
                gap: '6px',
              }}
            >
              <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '9px', letterSpacing: '2px', textTransform: 'uppercase', margin: 0 }}>FEATURED TOOL</p>
              <p style={{
                fontFamily: "'Permanent Marker', 'Comic Sans MS', cursive",
                fontSize: '14px',
                fontWeight: 700,
                color: '#ffffff',
                margin: 0,
                lineHeight: 1.1,
                letterSpacing: '0.5px',
                whiteSpace: 'pre-line',
              }}>
                {ad.title}
              </p>
              <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '10px', margin: 0 }}>{ad.tagline}</p>
              <span style={{
                display: 'inline-block',
                marginTop: '4px',
                background: '#ff6b2b',
                color: '#fff',
                fontSize: '10px',
                fontWeight: 600,
                padding: '4px 10px',
                borderRadius: '6px',
              }}>
                Visit Now →
              </span>
            </div>
          ) : (
            <div style={{padding: '5px', background: '#0a0a0f', borderRadius: '0 12px 12px 0', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)' }}>
              <p style={{
                background: '#0a0a0f',
                color: 'rgba(255,255,255,0.35)',
                fontSize: '9px',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                margin: 0,
                padding: '4px 10px',
              }}>FEATURED APP</p>
              <img
                src={mindSharperImg}
                alt="Mind Sharper"
                style={{ width: '200px', height: 'auto', display: 'block',  borderRadius: '12px', }}
              />
            </div>
          )}
        </a>

        <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', marginTop: '6px' }}>
          {ADS.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              aria-label={`Ad ${i + 1}`}
              style={{
                width: i === current ? '16px' : '6px',
                height: '6px',
                borderRadius: '3px',
                background: i === current ? '#ff6b2b' : 'rgba(255,255,255,0.25)',
                border: 'none',
                cursor: 'pointer',
                padding: 0,
                transition: 'all 0.3s',
              }}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

// ── Scroll To Top Button ──────────────────────────────────
function ScrollToTop() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 300);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Scroll to top"
      style={{
        position: 'fixed',
        bottom: '130px',
        right: '20px',
        zIndex: 998,
        width: '44px',
        height: '44px',
        borderRadius: '50%',
        background: '#111',
        border: '1.5px solid rgba(255,255,255,0.15)',
        color: 'rgba(255,255,255,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        boxShadow: '0 4px 20px rgba(0,0,0,0.4)',
        opacity: show ? 1 : 0,
        transform: show ? 'translateY(0)' : 'translateY(16px)',
        transition: 'opacity 0.3s, transform 0.3s',
        pointerEvents: show ? 'auto' : 'none',
      }}
    >
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path d="M9 14V4M4 9l5-5 5 5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </button>
  );
}

// ── Main Footer ───────────────────────────────────────────
export default function Footer() {
  const [openSection, setOpenSection] = useState(null);
  const toggle = (title) => setOpenSection(prev => prev === title ? null : title);

  return (
    <>
      <SideAds />
      <ScrollToTop />

     <footer className="bg-pure-black border-t border-white/10 rounded-t-[50px] md:rounded-t-[100px]">
        <div className="container-max py-16">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12">

            {/* Brand */}
            <div className="lg:col-span-2 flex flex-col items-center text-center lg:items-start lg:text-left">
              <Link to="/" className="flex items-center gap-2.5 mb-5" aria-label="CodeViora home">
                <img src={require('../images/Codeviora.webp')} alt="CodeViora Logo" className="h-8 w-auto object-contain" />
              </Link>
              <p className="text-white/40 text-sm leading-relaxed max-w-xs">
                End-to-end IT services — web development, design, apps, SEO, and digital marketing for businesses that want to grow.
              </p>
              <div className="flex items-center gap-3 mt-6">
                {SOCIALS.map(({ id, href, label, icon }) => (
                  <a
                    key={id}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="w-9 h-9 rounded-lg bg-white/5 dark:bg-white/5 hover:bg-white dark:bg-[#111] hover:text-black dark:hover:text-white dark:text-white flex items-center justify-center text-white/40 transition-all"
                  >
                    <i className={`${icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Desktop Links */}
            <div className="hidden md:contents">
              {FOOTER_SECTIONS.map(({ title, links }) => (
                <div key={title}>
                  <h3 className="text-xs font-semi-bold tracking-widest uppercase text-white/30 mb-5">{title}</h3>
                  <ul className="flex flex-col gap-3">
                    {links.map(([label, to]) => (
                      <li key={label}>
                        {to.startsWith('mailto:') || to.startsWith('tel:') ? (
                          <a href={to} className="text-sm text-white/40 hover:text-white transition-colors break-all">{label}</a>
                        ) : (
                          <Link to={to} className="text-sm text-white/40 hover:text-white transition-colors">{label}</Link>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            {/* Mobile Accordion */}
            <div className="md:hidden lg:hidden col-span-1 flex flex-col gap-0 border border-white/10 rounded-2xl overflow-hidden">
              {FOOTER_SECTIONS.map(({ title, links }) => (
                <div key={title} className="border-b border-white/10 last:border-b-0">
                  <button
                    onClick={() => toggle(title)}
                    className="w-full flex items-center justify-between px-5 py-4 text-left"
                    aria-expanded={openSection === title}
                  >
                    <span className="text-xs font-medium tracking-widest uppercase text-white/50">{title}</span>
                    <span className={`w-6 h-6 rounded-full border border-white/20 flex items-center justify-center text-white/50 transition-transform duration-300 flex-shrink-0 ${openSection === title ? 'rotate-45' : ''}`}>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M6 2v8M2 6h8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                      </svg>
                    </span>
                  </button>
                  <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openSection === title ? 'max-h-64 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <ul className="px-5 pb-4 flex flex-col gap-3">
                      {links.map(([label, to]) => (
                        <li key={label}>
                          {to.startsWith('mailto:') || to.startsWith('tel:') ? (
                            <a href={to} className="text-sm text-white/40 hover:text-white transition-colors break-all">{label}</a>
                          ) : (
                            <Link to={to} className="text-sm text-white/40 hover:text-white transition-colors">{label}</Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10">
          <div className="container-max py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-white/25 text-xs">© {new Date().getFullYear()} CodeViora. All rights reserved.</p>
            <p className="text-white/25 text-xs">Made in India 🇮🇳</p>
          </div>
        </div>
      </footer>
    </>
  );
}
